export default __webpack_public_path__ + "static/media/btn-enter-white-bg.4bc034f9.webp";